<template>
  <div class="text-center m-5">
    <div class="spinner-border text-primary"></div>
    <div>{{ text }}</div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: 'Warten auf Daten ...',
    },
  },
};
</script>

<style lang="scss" scoped></style>
